import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const CallEntryPage = () => {
  const { shortId } = useParams();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const validate = async () => {
      console.log(shortId)
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/meeting/validate/${shortId}`
        );

        console.log(res)

        if (res.data.valid) {
          // 🔥 redirect safely
          window.location.href = res.data.link;
        } else {
          setStatus("error");
          setMessage(res.data.message);
        }

      } catch (err) {
        console.error(err);

        const msg =
          err.response?.data?.message ||
          "This consultation link is no longer valid.";

        setStatus("error");
        setMessage(msg);
      }
    };

    validate();
  }, [shortId]);

  // 🔄 Loading state
  if (status === "loading") {
    return (
      <div className="h-screen flex items-center justify-center text-[#1E0E62]">
        <div>
          <p className="text-lg font-medium">Connecting you to your doctor...</p>
        </div>
      </div>
    );
  }

  // ❌ Error / expired state
  return (
    <div className="h-screen flex items-center justify-center text-center px-6">
      <div>
        <p className="text-lg font-semibold text-red-500 mb-2">
          Session Unavailable
        </p>
        <p className="text-gray-500">{message}</p>
      </div>
    </div>
  );
};

export default CallEntryPage;